export const validateGroupName = (name: string) => {
  switch (name) {
    case 'periodoSelectIds':
      return 'periodo'

    case 'empresaSelectIds':
      return 'empresasIds'

    case 'mundoSelectIds':
      return 'mundosIds'

    case 'categoriaCompactaSelectIds':
      return 'categoriasCompactasIds'

    case 'categoriaSelectIds':
      return 'categoriasIds'

    default:
      return null
  }
}
